import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { firestore } from '../firebase';
import { timesObj } from '../times';
const Container = styled.div`
  display: flex;
`;

const SingleTime = styled.div`
  margin: 0.2rem;
  padding: 0.2rem;
  font-family: 'Open Sans', sans-serif;
`;

const Title = styled.p`
  /* font-weight: bold; */
  margin: 0;
  text-align: center;
  font-family: 'Open Sans', sans-serif;
`;

const StyledTitle = styled.p`
  font-weight: bold;
  margin: 0;
  margin-bottom: 3px;
  font-family: 'Open Sans', sans-serif;
`;

const Timings = styled.p`
  margin: 0;
  color: grey;
  font-family: 'Open Sans', sans-serif;
`;

const StyledDate = styled.p`
  font-family: 'Open Sans', sans-serif;
  margin: 0;
`;

const months = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December',
};

export async function fetchFromAPI(month) {
  console.log('month', month);
  const res = await fetch(
    `https://www.londonprayertimes.com/api/times/?format=json&key=f3384cf4-e66d-44cd-9ca1-ef294d759f64&year=2022&${month}=july&24hours=true`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  if (res.status === 200) {
    return res.json();
  } else {
    throw new Error(res.statusText);
  }
}

export function SalaahTimes() {
  const dateObj = new Date();
  const Month = dateObj.getUTCMonth() + 1; //months from 1-12
  const Day = dateObj.getUTCDate();
  const Year = dateObj.getUTCFullYear();

  const todayDate =
    Year +
    '-' +
    (/^\d$/.test(Month) ? '0' + Month : Month) +
    '-' +
    (/^\d$/.test(Day) ? '0' + Day : Day);

  const times = timesObj.times[todayDate];
  const [jamaatTimes, setJamaatTimes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const getData = async () => {
    setLoading(true);
    try {
      firestore
        .collection('salaah')
        .doc('timesObj')
        .onSnapshot((doc) => {
          setJamaatTimes(doc.data());
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    if (!jamaatTimes) {
      getData();
    }
  }, [jamaatTimes]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error Loading Prayer Times!</div>;
  }

  if (!jamaatTimes) {
    return null;
  }
  return (
    <div className="App">
      <Container>
        <div style={{ marginRight: '70px', marginBottom: '0' }}>&nbsp;</div>
        <StyledDate>{`${Day} ${months[Month - 1]} ${Year}`}</StyledDate>
      </Container>

      <Container>
        <>
          <SingleTime>
            <div style={{ marginBottom: '3px' }}>&nbsp;</div>
            <Timings>Begins</Timings>
            <Timings>Jamā‘ah</Timings>
          </SingleTime>
          <SingleTime>
            <StyledTitle>Fajr</StyledTitle>
            <Title> {times.fajr}</Title>
            <Title>{jamaatTimes.fajr}</Title>
          </SingleTime>
          <SingleTime>
            <StyledTitle>Dhuhr</StyledTitle>
            <Title>{times.dhuhr}</Title>
            <Title>{jamaatTimes.dhuhr}</Title>
          </SingleTime>

          <SingleTime>
            <StyledTitle>Asr</StyledTitle>
            <Title>{times.asr}</Title>
            <Title>{jamaatTimes.asr}</Title>
          </SingleTime>

          <SingleTime>
            <StyledTitle>Maghrib</StyledTitle>
            <Title>{times.magrib}</Title>
            <Title>{times.magrib_jamat}</Title>
          </SingleTime>

          <SingleTime>
            <StyledTitle>Isha</StyledTitle>
            <Title>{times.isha}</Title>
            <Title>{jamaatTimes.isha}</Title>
          </SingleTime>
        </>
      </Container>
    </div>
  );
}
